<template>
    <div class="sa-list-component">
        <b-form @submit.prevent="onSubmit">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Struttura:</label>
                    <b-form-select v-model="filtro.codiceStruttura" text-field="denominazione" value-field="codiceStruttura" :options="struttureOptions">
                        <template #first>
                            <b-form-select-option :value="null"> TUTTE </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Nome Consenso:</label>
                    <b-form-input v-model="filtro.nomeConsenso"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Tipologia:</label>
                    <b-form-select v-model="filtro.tipologia" :options="tipologiaOptions"> </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                    <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </b-form>
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table :selectable="selectable" selectMode="single" sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table" @row-selected="onRowSelected">
                    <template #cell(index)="row">
                        {{ row.index + 1 }}
                    </template>
                    <template v-slot:cell(updateDate)="{ item }">
                        {{ formatDateTime(item.updateDate) }}
                    </template>
                    <template #cell(actions)="{ item }">
                        <b-container v-if="!selectable" class="btn-table-action-section">
                            <b-button size="sm" variant="outline-primary outline-primary-noborder pull-right" v-b-tooltip.hover title="Associa Sede" @click="onClickAssociaSede(item)">
                                <b-icon icon="building"></b-icon>
                            </b-button>
                            <b-button size="sm" variant="outline-primary outline-primary-noborder pull-right" v-b-tooltip.hover title="Associa Profili" @click="onClickAssociaProfili(item)">
                                <b-icon icon="people-fill"></b-icon>
                            </b-button>
                            <b-button size="sm" variant="outline-purple outline-purple-noborder pull-right" v-b-tooltip.hover title="Visualizza Preview" @click="onClickPreview(item)">
                                <i class="far fa-file-pdf"></i>
                            </b-button>

                            <b-button size="sm" v-b-tooltip.hover title="Modifica Consenso" variant="outline-success outline-secondary-noborder pull-right" @click="onClickEdit(item)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <consensi-preview-modal-component ref="mdlPreviewConsensi" />
        <consensi-profili-list-modal-component ref="mdlConsensiProfiliListModalComponent" />
        <consensi-strutture-list-modal-component ref="mdlConsensiStruttureListModalComponent" />
    </div>
</template>

<script>
import ConsensiProfiliListModalComponent from "./ConsensiProfiliListModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import ConsensiPreviewModalComponent from "./ConsensiPreviewModalComponent.vue";
import ConsensiStruttureListModalComponent from "./ConsensiStruttureListModalComponent.vue";
export default {
    props: {
        selectable: { type: Boolean, default: false },
    },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [UtilityMixin],
    components: { ConsensiPreviewModalComponent, ConsensiProfiliListModalComponent, ConsensiStruttureListModalComponent },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/consensi",
            struttureOptions: [],
            filtro: {
                nomeConsenso: null,
                codiceStruttura: null,
                sezione: null,
                tipologia: null,
            },
            tipologiaOptions: [
                { text: "TUTTI", value: null },
                { text: "FACOLTATIVO", value: "FACOLTATIVO" },
                { text: "OBBLIGATORIO", value: "OBBLIGATORIO" },
            ],
            items: [],
            sezione: "",
            listKey: 0,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Nome",
                    key: "nomeConsenso",
                    sortable: true,
                    //thStyle: "width: 7rem",
                },
                {
                    label: "Data Ultima Modifica",
                    key: "updateDate",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Tipologia",
                    key: "tipologia",
                    sortable: true,
                    thStyle: "width: 7rem",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 7rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    // mounted() {
    //     let me = this;
    //     me.loadData();
    // },
    methods: {
        init(filtro, pathResource) {
            let me = this;
            me.filtro = filtro;
            // console.log(filtro);

            this.loadStrutture();
            if (pathResource) {
                this.pathResource = pathResource;
            }
            if (filtro["sezione"]) {
                this.sezione = filtro["sezione"];
            }
            me.loadData();
        },
        openModalNuovoCosenso() {
            this.$router.push("/consensi/edit/-1");
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            me.items = [];
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConsensi"]) {
                me.filtro = JSON.parse(sessionStorage["filtroConsensi"]);
            }
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;
            if (this.sezione != null) {
                me.filtro.sezione = this.sezione;
            }
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.$emit("afterLoadData");
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        loadDataError(response) {
            let me = this;
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickPreview(item) {
            this.$refs.mdlPreviewConsensi.preview(item.id, item.dataModel);
        },
        onClickView(item) {
            this.$router.push("/consensi/view/" + item.id);
        },
        onClickEdit(item) {
            this.$router.push("/consensi/edit/" + item.id);
        },
        onRowSelected(item) {
            let obj = null;
            if (item.length > 0) {
                obj = item[0];
            }
            this.$emit("rowSelected", obj);
        },
        onClickAssociaProfili(consenso) {
            this.$refs.mdlConsensiProfiliListModalComponent.init(consenso);
        },
        onClickAssociaSede(consenso) {
            this.$refs.mdlConsensiStruttureListModalComponent.init(consenso);
        },
        onSubmit() {
            let sessionStorage = window.sessionStorage;

            sessionStorage["filtroConsensi"] = JSON.stringify(this.filtro);
            this.init(this.filtro);
        },
        onReset() {
            let sessionStorage = window.sessionStorage;
            this.filtro = {
                nomeConsenso: null,
                codiceStruttura: null,
                sezione: null,
                tipologia: null,
            };
            sessionStorage["filtroConsensi"] = JSON.stringify(this.filtro);
            this.init(this.filtro);
        },
        loadStrutture() {
            UtilityMixin.methods.loadDataResources("/strutture", {}, this.loadStruttureSuccess, this.loadStruttureError);
        },
        loadStruttureSuccess(response) {
            this.struttureOptions = response.data.data;
        },
        loadStruttureError(error) {
            console.log(error);
        },
    },
};
</script>

<style>
.sa-alert-descrizione {
    font-style: italic;
}

.btn-table-action-section {
    gap: 2px;
}
</style>
